export const enmuFunctions = {
  'ATTEND_SET_LBS': 'attendance_set_lbs'
};
export const OBJ_DISABLED_VALUES = [6]; // 功能置灰的所有值
export const OBJ_HIDDEN_VALUES = [0, 1, 3, 5]; // 功能隐藏的所有值
export const OBJ_CUSTOM_VALUES = [4, 7]; // 功能自定义的所有值

export const OBJ_ENABLED_VALUES = [2, 3, 4]; // 功能可用状态
export const getAllFunctions = () => {
  return JSON.parse(window.sessionStorage.getItem('yxt_factors')) || {};
};
export const checkTimeOutFnc = (point) => {
  const localFactors = getAllFunctions();
  return localFactors[point] && localFactors[point].webState;
};
export const getFunStatus = (funCode) => {
  try {
    // 1.未购买-禁用-隐藏 2.未购买-禁用-置灰 3.未购买-禁用-自定义
    // 4.已购买-启用-显示 5.已购买-启用-隐藏 6.已购买-启用-自定义
    // 7.已购买-禁用-隐藏 8.已购买-禁用-置灰 9.已购买-禁用-自定义
    // 10.已过期-禁用-隐藏 11.已过期-禁用-置灰 12.已过期-禁用-自定义

    // console.log(funCode, objStatus)
    // return {
    //   disabled: true,
    //   hidden: false
    // };
    return {
      disabled: OBJ_DISABLED_VALUES.indexOf(funCode) >= 0,
      hidden: OBJ_HIDDEN_VALUES.indexOf(funCode) >= 0,
      custom: OBJ_CUSTOM_VALUES.indexOf(funCode) >= 0,
      enabled: OBJ_ENABLED_VALUES.indexOf(funCode) >= 0,
      value: funCode
    };
  } catch (error) {
    return {};
  }
};
